import { render, staticRenderFns } from "./bulma_wizard_container.vue?vue&type=template&id=6c32055d&scoped=true&lang=html"
import script from "./bulma_wizard_container.vue?vue&type=script&lang=js"
export * from "./bulma_wizard_container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c32055d",
  null
  
)

export default component.exports